import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Container } from './ui/Container';
const metrics = [{
  value: 70,
  suffix: '%',
  label: 'Faster RFI turnaround'
}, {
  value: 100,
  suffix: '%',
  label: 'Audit-ready by default'
}, {
  value: 40,
  suffix: '+',
  label: 'Hours reclaimed per analyst / month'
}, {
  value: 0,
  suffix: '',
  label: 'Spreadsheets required'
}];
function Counter({
  value,
  suffix
}: {
  value: number;
  suffix: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = value / (duration / 16); // 60fps
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} className="text-5xl md:text-6xl font-display font-bold text-iris-green" data-id="element-141">
      {count}
      {suffix}
    </span>;
}
export function ImpactMetrics() {
  return <section className="py-16 bg-iris-surface border-y border-iris-border" data-id="element-142">
      <Container data-id="element-143">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-iris-border/50" data-id="element-144">
          {metrics.map((metric, index) => <div key={index} className="flex flex-col items-center text-center px-4 first:pl-0 last:pr-0" data-id="element-145">
              <Counter value={metric.value} suffix={metric.suffix} data-id="element-146" />
              <span className="text-sm font-mono text-iris-muted mt-2 uppercase tracking-wider" data-id="element-147">
                {metric.label}
              </span>
            </div>)}
        </div>
      </Container>
    </section>;
}